// Свой ли это профиль. Писать себе, запрашивать у себя приватки, открывать
// себя как «чужой профиль» нельзя — сервер это пропускал, поэтому режем на клиенте.
import { canonicalizeProfileId } from "./profileId";

export const isSelfId = (id: any, idProfile: any): boolean => {
  const a = canonicalizeProfileId(id);
  const b = canonicalizeProfileId(idProfile);
  return !!a && !!b && a === b;
};

export const withoutSelf = <T = any>(list: T[] | null | undefined, idProfile: any, getId: (el: T) => any): T[] =>
  (Array.isArray(list) ? list : []).filter((el) => !isSelfId(getId(el), idProfile));
